
define('NSeComm.WebsiteCustomizations.Main', [
    'NSeComm.WebsiteCustomizations.Main.View'
], function NSeCommWebsiteCustomizationsMain(
        NSeCommWebsiteCustomizationsView
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            /** @type {LayoutComponent} */
            // Como es suite commerce no conviene hacerlo de la otra manera, porque cambia la version y se rompe
            // var layout = container.getComponent('Layout');

            var PDP = container.getComponent('PDP');
            if (PDP){
            PDP.addChildViews(PDP.PDP_FULL_VIEW, {
                'Quantity.Pricing': {
                    'NSeComm.WebsiteCustomizations.Main.View': { // es un identificador interno
                        childViewIndex: 1,
                        childViewConstructor: function () {
                            return new NSeCommWebsiteCustomizationsView();
                        }
                    }
                }
            });
            }
            // var CartSummary = container.getComponent('CartSummary');
            // _(CartSummary.prototype).extend({
            //     initialize: _(CartSummary.prototype.initialize).wrap(function initializeWrapped(fn) {
            //         var result = fn.apply(this, _(arguments).toArray().slice(1));
            //         this.on('afterViewRender', function afterRender() {
            //             this.$('.cart-summary-shipping-cost-applied').addClass('cart-summary-grid-float-parent');
            //             // this.$('.cart-summary-grid-float').remove();
            //         });
            //
            //         return result;
            //     })
            // });

            // _(ProductDetailsFullView.prototype).extend({
            //     initialize: _(ProductDetailsFullView.prototype.initialize).wrap(function initializeWrapped(fn) {
            //         var result = fn.apply(this, _(arguments).toArray().slice(1));
            //         this.on('afterViewRender', function afterRender() {
            //             this.$('.product-list-control-button-wishlist').replace('WISHLIST', 'QUICKLIST');
            //             this.$('.product-detail-to-quote-add-to-quote-button').remove();
            //             // this.$('.cart-summary-grid-float').remove();
            //         });
            //
            //         return result;
            //     })
            // });
        }
    };
});
